import React, { useCallback } from 'react'

export function usePersistedState<S>(key: string, defaultValue: S): [S, (input: S) => void] {
  const [state, internalSetState] = React.useState<S>(() => {
    const initialValue = window.localStorage.getItem(key)

    return initialValue ? JSON.parse(initialValue) : defaultValue
  })

  const setState = useCallback(
    (input: S) => {
      internalSetState(input)
      window.localStorage.setItem(key, JSON.stringify(input))
    },
    [internalSetState]
  )

  return [state, setState]
}
